import { render, staticRenderFns } from "./list-pulso.vue?vue&type=template&id=51281b94"
import script from "./list-pulso.vue?vue&type=script&lang=js"
export * from "./list-pulso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports